export const REVIEW_CONSTANTS = {
  title: "Real-World Success Stories ",
  desc: "Enterprise-grade cloud infrastructure, fully managed and secure for your business needs",
  list: [
    {
      text: "“OneMind helped us migrate 1200+ VMs from VMware to MOST with zero impact to production. Their playbooks, automation, and care made it seamless.”",
      name: "National Retail Chain ",
      designation: "Director of Infrastructure",
    },
    {
      text: "“We wanted to leave Nutanix without rearchitecting our entire stack. OneMind made it possible”",
      name: "Healthcare SaaS Platform ",
      designation: "CTO",
    },
  ],
};
